// removed by extract-text-webpack-plugin
module.exports = {"Popup":"BeverageCustomPopup__Popup__3tGsC","CenteredDiv":"BeverageCustomPopup__CenteredDiv__3UeUZ","DrinkDiv":"BeverageCustomPopup__DrinkDiv__11IXa"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/BeverageCustomPopUp/BeverageCustomPopup.css
// module id = 161
// module chunks = 0